import { defineStore } from 'pinia';
export const useLanguageStore = defineStore('__mall_language__', {
  state: function () {
    return {
      currentCountry: {
        key: 'other',
        label: 'other'
      },
      currentLanguage: {
        key: 'zh',
        label: '中文'
      }
    };
  },
  actions: {
    setCurrentCountry(country) {
      console.log('currentCountry', country);
      this.currentCountry = country;
    },
    setCurrentLanguage(language) {
      this.currentLanguage = language;
    }
  },
  persist: {
    key: '__mall_language__',
    storage: localStorage,
    paths: ['currentLanguage', 'currentCountry']
  }
});